/* eslint-disable camelcase */
import { AxiosRequestConfig } from "axios";

import { IResolve } from "@/types/communal";
import { IOSSUploadRequest, IUploadResult } from "@/types/oss";

import { api } from "./api";

/**
 * 上传图片、文件
 * @returns
 */
export const uploadFileApi = async (
  data: IOSSUploadRequest,
  config?: AxiosRequestConfig
): Promise<IResolve<IUploadResult>> => {
  const formData = new FormData();

  formData.append("file", data.file);

  return await api.post("/oss/uploadFile", formData, config);
};

/**
 * 通過文件链接获取oss上传结果
 * @param fileUrl 文件链接
 * @returns 播客设置
 */
export const uploadFileByUrlApi = async (
  fileUrl: string
): Promise<IResolve<IUploadResult>> => {
  return await api.post(`/oss/uploadFileByUrl`, {
    file_url: fileUrl,
    timeout: 3 * 24 * 60,
  });
};
